import { gql } from "graphql-tag";

export const instagramV2 = gql`
  fragment Home_page_v2_instagram_v2 on Home_page_v2SlicesInstagram_v2 {
    type
    variation {
      ... on Home_page_v2SlicesInstagram_v2Default {
        primary {
          subtitle
          username
          instagram_link {
            _linkType
            ... on _ExternalLink {
              url
              target
            }
          }
        }
      }
    }
  }
`;
